import React from 'react'
import Plot from 'react-plotly.js'
import { Box, Typography } from '@mui/material'

interface BoatModelData {
    model: string
    count: number
}

interface BoatModelChartProps {
    title: string
    data: BoatModelData[]
}

export const BoatModelChart: React.FC<BoatModelChartProps> = ({
    title,
    data,
}) => {
    const sortedData = [...data].sort((a, b) => b.count - a.count)

    return (
        <Box sx={{ height: '100%', bgcolor: '#404040', p: 1 }}>
            <Typography
                variant="subtitle2"
                color="white"
                sx={{ mb: 1, textAlign: 'center' }}
            >
                {title}
            </Typography>
            <Plot
                data={[
                    {
                        type: 'bar',
                        orientation: 'h',
                        x: sortedData.map((item) => item.count),
                        y: sortedData.map((item) => item.model),
                        marker: {
                            color: '#FFA726',
                            opacity: 0.8,
                        },
                        text: sortedData.map((item) => item.count.toString()),
                        textposition: 'outside',
                        textfont: {
                            color: 'white',
                            size: 10,
                        },
                        hovertemplate:
                            '<b>%{y}</b><br>Count: %{x}<extra></extra>',
                    },
                ]}
                layout={{
                    height: 280,
                    margin: { t: 10, r: 40, l: 80, b: 30 },
                    paper_bgcolor: '#404040',
                    plot_bgcolor: '#404040',
                    font: {
                        color: 'white',
                        family: 'Roboto, sans-serif',
                        size: 10,
                    },
                    xaxis: {
                        gridcolor: '#555555',
                        showgrid: true,
                        zeroline: false,
                        tickfont: { color: 'white', size: 9 },
                        range: [
                            0,
                            Math.max(...sortedData.map((item) => item.count)) *
                                1.2,
                        ],
                        fixedrange: true,
                    },
                    yaxis: {
                        gridcolor: 'transparent',
                        showgrid: false,
                        zeroline: false,
                        tickfont: { color: 'white', size: 9 },
                        automargin: true,
                        fixedrange: true,
                    },
                    showlegend: false,
                    bargap: 0.3,
                    autosize: true,
                }}
                config={{
                    displayModeBar: false,
                    responsive: true,
                    staticPlot: false,
                    autosizable: true,
                }}
                useResizeHandler={true}
                style={{ width: '100%', height: '280px' }}
            />
        </Box>
    )
}
